import FixaSearch from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import type { ChangeEvent } from "react";
import styles from "./SheetHeader.module.css";

interface SheetHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  showSearch: boolean;
}

// title/description/search render in the body, below the floating close button
export function SheetHeader({
  searchQuery,
  onSearchChange,
  showSearch,
}: SheetHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["root"]}>
      <FixaText tagName="h1" textStyle="Heading.M" className={styles["title"]}>
        {t("moveUsersToDifferentTeamString")}
      </FixaText>
      <p className={styles["description"]}>
        {t("moveUsersToDifferentTeamDescriptionString")}
      </p>

      {showSearch && (
        <div className={styles["search-wrapper"]}>
          <FixaSearch
            id="move-users-to-team-search"
            data-testid="move-users-to-team-search"
            placeholder={t("searchTeamString")}
            value={searchQuery}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onSearchChange(e.target.value)
            }
            onClear={() => onSearchChange("")}
          />
        </div>
      )}
    </div>
  );
}
